import { BCMSCurrency, BCMSDate, BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import OneTimeACHPaymentPage, { getDefaultData, getDefaultUI } from "components/pages/OneTimeACHPaymentPage";
import Classes, { ACHFromAccount, ACHToParticipant, Account } from "model";

export default function CaptureParticipantAmountAdded02(props) {
    const context = useBCMSContext();

    BCMSRecord.globalControllerFor(Classes, context);

    const effectiveDate = BCMSDate.init().nextBusinessDay().nextBusinessDay();
    const addedAccount = ACHFromAccount.init({ account: "6", id: ACHFromAccount.nextID(), amount: "5000.00" });
    const defaultData = getDefaultData();

    const { state } = context ?? {};
    const { branding } = state ?? {};
    const { options } = branding ?? {};

    let achToParticipants = defaultData.achToParticipants.participants;
    let nextID = undefined;
    if(achToParticipants.length === 0) {
        // check ids globally
        nextID = ACHToParticipant.nextID();
    } else {
        nextID = achToParticipants.length;
    }

    const participants = defaultData.participants.reduce((acc, item, i) => {
        item.isSelected = "true";
        acc.push(item);
        return acc;
    }, []);

    const updatedACHToParticipants = participants.reduce((acc, item, i) => {
        if(item.isSelected === "true") {
            let amount = undefined;
            if(i === 0) {
                amount = "2000.00";
            } else if(i === 1) {
                amount = "1000.00";
            }
            const added = ACHToParticipant.init({ id: nextID, participant: item.id,
                 oneTimeACHPayment: defaultData.oneTimeACHPayment, notify: "No", addenda: "0", amount: amount });
            nextID = parseFloat(nextID) + 1;
            acc.push(added);
        }
        return acc;
    }, []);
    achToParticipants = [ ...updatedACHToParticipants, ...achToParticipants ];
    
    let data = BCMSStateManagerCRUD.init(defaultData)
        .update([ "oneTimeACHPayment", "transactionType" ], "payment")
        .update([ "oneTimeACHPayment", "secCode" ], "CCD Credit - Non-Consumer Credit")
        .update([ "oneTimeACHPayment", "scheduleType" ], "future dated")
        .update([ "oneTimeACHPayment", "effectiveDate" ], effectiveDate)
        .update([ "oneTimeACHPayment", "companyEntryDescription" ], "ACH PMT")
        .update([ "oneTimeACHPayment", "company" ], "0")
        .update([ "achFromAccounts", "accounts" ], [ addedAccount ])
        .update([ "participants" ], participants)
        .update([ "achToParticipants", "participants" ], updatedACHToParticipants)
    
    if(options.offset_account_ui_abi22 === "Single Account") {
        data.update([ "oneTimeACHPayment", "debitAmount" ], BCMSCurrency.init(3000));
        data.update([ "selectedOffsetAccount", "account" ], Account.initByID("6"))
    }

    data = data.submit();

    const ui = BCMSStateManagerCRUD.init(getDefaultUI())
    .update([ "showOneTimeACHModal", "isActive" ], false)
    .update([ "showSecCode", "isActive" ], true)
    .submit();

    return <OneTimeACHPaymentPage data={ data } ui={ ui } />;
}